import { createContext } from 'react'

const viewportContext = createContext('viewport')

export default viewportContext